import { Container, Row, Col, Button, Card } from "react-bootstrap";
import styles from "@/styles/Questions.module.scss";
import { useRouter } from "next/router";
import ScheduleCallModal from "../ScheduleCallModal";
import { useState } from "react";
export default function Questions() {
  const router = useRouter();
  const [modal, setModal] = useState(false);

  return (
    <div className={styles.que}>


      <Container
        fluid
        className={`margin-x bg-light-gray `}
      >
        <Row className="que-container justify-content-between gap-159" fluid>
          <Col className="w-636">
            <h2 className="question">Have questions about our products or services?</h2>
            <p className="text">We're here to help.</p>
            <p className="text-description">
              Let’s collaborate to find the right solution for your needs.
            </p>
          </Col>
          <Col className="w-410">
            <Row className="">
              <Col md={8} className="mb-3">
                <Card

                >
                  <Card.Body className={`${styles.buttonAnimate} card-padding`}>
                    <Card.Title className="begin m-0">Begin your journey!</Card.Title>

                    <Button className="animated-button" onClick={() => router.push('/contact-us/')}>
                      <span className="complete">Complete the form and Cubet will connect with you soon!</span>
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={12} className="mb-3">
                <Card

                >
                  <Card.Body className={`${styles.buttonAnimate} card-padding`}>
                    <Card.Title className="begin m-0">Need more help?</Card.Title>

                    <Button className="animated-button" onClick={() => setModal(true)}>
                      <span className="complete">Schedule an expert consultation to discuss your tech requirements.</span>
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        {modal && <ScheduleCallModal visible={modal} setVisible={setModal} />}
      </Container>

    </div>
  );
}
